<template>
  <!-- 性价比解读 -->
  <div
    v-if="costPerformanceText || fineDiscount"
    v-zpm="{
      sortname: '性价比解读模块',
      sortid: 10,
      backup: {
        moduleContent: fineDiscount && fineDiscount.labelId
      },
      legoareabackup: {
        sortName: '性价比解读模块',
        sortid: 10,
        moduleContent: fineDiscount && fineDiscount.labelId
      },
      areaexposure: 105
    }"
    class="cost-performance"
    :class="{ 'cost-performance__super': superColor }"
    @click="listenClickTab"
  >
    <img
      class="first-icon"
      :src="
        $setPicSize(
          superColor
            ? 'https://pic5.zhuanstatic.com/zhuanzh/aa9fe111-f2f0-4e49-9051-e874d4b4816f.png'
            : 'https://pic4.zhuanstatic.com/zhuanzh/356aa995-aebf-4e37-8149-cdcaee988d5f.png'
        )
      "
      alt=""
    />
    <div
      v-if="fineDiscount"
      class="fine-discount-text"
      :class="{
        'no-cost-text': !costPerformanceText
      }"
    >
      {{ fineDiscount.tagName }}
    </div>
    <div v-if="costPerformanceText" class="cost-desc">
      {{ costPerformanceText }}
    </div>
    <img
      class="end-icon"
      :src="
        $setPicSize(
          superColor
            ? 'https://pic5.zhuanstatic.com/zhuanzh/6cb75868-3b1b-4b27-a5a8-ce8e7eb6989c.png'
            : 'https://pic1.zhuanstatic.com/zhuanzh/a2e5f522-bb31-4c8c-b2d8-91ac67f58a66.png'
        )
      "
      alt=""
    />
  </div>
</template>
<script>
import { defineComponent, inject } from '@vue/composition-api'
export default defineComponent({
  props: {
    costPerformanceText: {
      type: String,
      default: () => ''
    },
    superColor: {
      type: Boolean,
      default: false
    },
    fineDiscount: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  setup() {
    const listenClickTab = inject('listenClickTab') || '' // 性价比解读点击事件
    return {
      listenClickTab
    }
  }
})
</script>
<style lang="scss" scoped>
.cost-performance {
  display: flex;
  align-items: center;
  margin-top: 18px;
  font-family: PingFangSC-Light, PingFang SC;
  line-height: 22px;

  &__super {
    .cost-desc,
    .fine-discount-text {
      color: #ffffff !important;
    }
    .fine-discount-text {
      font-weight: 400 !important;
      font-family: PingFangSC-Regular, PingFang SC !important;
    }
  }
  .first-icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
  .fine-discount-text {
    margin-right: 20px;
    color: #111111;
    font-weight: 300;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 22px;
    white-space: nowrap;
  }
  .no-cost-text {
    margin-right: 6px;
  }

  .cost-desc {
    max-width: 320px;
    margin-right: 6px;
    overflow: hidden;
    color: #999999;
    font-weight: 300;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 22px;
    white-space: nowrap;
    opacity: 0.7;
  }
  .end-icon {
    width: 10px;
    height: 18px;
    opacity: 0.7;
  }
}
</style>
